<template>
  <MasterdataTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :table-data="tableData"
    :sort-by="sortBy"
    :actions="actions"
    :refetch="refetch"
    :components="components"
  />
</template>

<script>
import gql from 'graphql-tag'
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import MasterdataBusMatrixCreateModal from './MasterdataBusMatrixCreateModal'
import MasterdataBusMatrixEditModal from './MasterdataBusMatrixEditModal'
import MasterdataBusMatrixDeleteModal from './MasterdataBusMatrixDeleteModal'

export default {
  name: 'MasterdataBusMatrix',

  components: {
    MasterdataTableContainer
  },

  data() {
    return {
      components: {
        createModal: {
          component: MasterdataBusMatrixCreateModal,
          title: 'Skapa'
        }
      },
      actions: [
        {
          title: 'Redigera',
          icon: 'mdi-pencil',
          component: MasterdataBusMatrixEditModal,
          type: 'edit'
        },
        {
          title: 'Ta bort',
          icon: 'mdi-delete',
          component: MasterdataBusMatrixDeleteModal,
          type: 'delete'
        }
      ],
      sortBy: 'updated',
      headers: [
        {
          text: 'Från plats',
          value: 'from_place'
        },
        {
          text: 'Till plats',
          value: 'to_place'
        },
        {
          text: 'Tid (minuter)',
          value: 'duration'
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'right'
        }
      ]
    }
  },

  apollo: {
    busDurationMap: {
      query: gql`
        query busDurationMap {
          busDurationMap {
            from_place
            to_place
            duration
          }
        }
      `
    }
  },

  methods: {
    refetch() {
      this.$apollo.queries.busDurationMap.refetch()
    }
  },

  computed: {
    tableData() {
      return this.busDurationMap || []
    }
  }
}
</script>
